import { render, staticRenderFns } from "./OneTemplatePage.vue?vue&type=template&id=e5d1357a&scoped=true"
import script from "./OneTemplatePage.vue?vue&type=script&lang=js"
export * from "./OneTemplatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d1357a",
  null
  
)

export default component.exports